import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toNumber'
})
export class ToNumberPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let number = value && typeof value == 'string' ? parseFloat(value.replace(/,/g, '')) : value;
    return number;
  }

}
